export enum Validity {
  NOT_VALID_YET = 'NOT_VALID_YET',
  EXPIRING_SOON = 'EXPIRING_SOON',
  EXPIRED = 'EXPIRED',
  VALID = 'VALID',
}
